export default "__VITE_ASSET__BaP3QbQG__"